import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import selectPerson from '@/components/select-person';
import { queryDocGatherList, issuedDocGather, queryIsDelayDocument } from '@/api/notice/documentApi.js';
export default {
  data: function data() {
    var validateSendList = function validateSendList(rule, value, callback) {
      if (value.organData.length === 0 && value.postData.length === 0 && value.userData.length === 0) {
        callback(new Error('请选择下发到'));
      } else {
        callback();
      }
    };
    return {
      userInfo: this.$hdk.userInfo.get(),
      form: {
        fileName: undefined,
        createTime: []
      },
      columns: [{
        title: '收文编号',
        dataIndex: 'fileCode',
        align: 'center',
        width: 120
      }, {
        title: '收文标题',
        dataIndex: 'fileName',
        align: 'center',
        width: 120
      }, {
        title: '发送人',
        dataIndex: 'sendUser',
        align: 'center',
        width: 200,
        scopedSlots: {
          customRender: 'sendUser'
        }
      }, {
        title: '收文日期',
        dataIndex: 'reDate',
        align: 'center',
        width: 120
      }, {
        title: '允许下发',
        dataIndex: 'isIssue',
        align: 'center',
        width: 80,
        scopedSlots: {
          customRender: 'isIssue'
        }
      }, {
        title: '收文类型',
        dataIndex: 'isMajor',
        align: 'center',
        width: 80,
        scopedSlots: {
          customRender: 'isMajor'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 80,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      tableData: [],
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      paginationTable: {
        total: 0,
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: this.onShowSizeChange,
        onChange: this.pageChange
      },
      personPickShow: false,
      sendForm: {
        organPostId: [],
        dodId: undefined,
        isIssue: undefined,
        result: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        }
      },
      rules: {
        isIssue: [{
          required: true,
          message: '请选择是否继续下发',
          trigger: 'change'
        }],
        result: [{
          required: true,
          message: '请选择下发到',
          trigger: 'change',
          validator: validateSendList
        }]
      },
      options: []
    };
  },
  components: {
    selectPerson: selectPerson
  },
  methods: {
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      this.sendForm.result.organId = value[0];
      this.sendForm.result.postId = value[1];
    },
    handleSubmit: function handleSubmit() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.loadData();
    },
    viewProcessClick: function viewProcessClick(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, req;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return queryIsDelayDocument({
                docId: row.docId
              });
            case 1:
              res = _context.v;
              if (!(res.data.data === 1)) {
                _context.n = 2;
                break;
              }
              _this.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 2:
              req = {
                id: row.docId,
                isMajor: row.isMajor,
                isIssue: row.isIssue
              };
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(req));
              _this.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: req,
                  backto: 'put',
                  isMajor: row.isMajor,
                  isIssue: row.isIssue
                }
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    distribute: function distribute(row) {
      this.personPickShow = true;
      this.sendForm.docId = row.docId;
      this.sendForm.isIssue = row.isIssue;
    },
    loadData: function loadData() {
      var _this2 = this;
      var req = {
        queryStr: this.form.fileName,
        startDate: this.form.createTime.length > 0 ? this.form.createTime[0] + ' 00:00:00' : '',
        endDate: this.form.createTime.length > 0 ? this.form.createTime[1] + ' 23:59:59' : '',
        currentNo: this.paginationTable.current,
        pageSize: this.paginationTable.pageSize
      };
      queryDocGatherList(req).then(function (res) {
        if (res.data.code == 200) {
          _this2.tableData = res.data.data.rows;
          _this2.paginationTable.total = res.data.data.total;
        }
      });
    },
    onShowSizeChange: function onShowSizeChange(current, pageSize) {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function pageChange(page, pageSize) {
      this.paginationTable.current = page;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.personPickShow = false;
      this.$refs.searchFrom.resetFields();
    },
    submitSend: function submitSend() {
      var _this3 = this;
      this.$refs.sendForm.validate(function (valid) {
        if (valid) {
          issuedDocGather(_this3.sendForm).then(function (res) {
            if (res.data.code == 200) {
              _this3.$message.success('分发成功');
              _this3.handleCancel();
              _this3.paginationTable.current = 1;
              _this3.loadData();
            }
          });
        } else {
          return false;
        }
      });
    },
    viewReadStatus: function viewReadStatus(row) {
      this.$router.push({
        path: '/docNotice/doc/docReadStatus',
        query: {
          docId: row.docId
        }
      });
    }
  },
  mounted: function mounted() {
    var userInfo = this.userInfo;
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
    this.loadData();
  }
};